export class DartFormat {
  static kst(value: string | null | undefined): string {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleString('sv-SE', { timeZone: 'Asia/Seoul' }).replace('T', ' ');
  }

  static json(value: unknown): string {
    return typeof value === 'string' ? value : JSON.stringify(value, null, 2);
  }
}

export class ConfigLines {
  /**
   * `config` 객체 → 편집용 `key=value` 줄.
   *
   * 문자열이 아닌 값은 JSON으로 적는다 — `String({})`은 `[object Object]`가 되어 되돌릴 수 없는데,
   * 저장하면 서버가 그 문자열을 그대로 넣어 값이 망가진다.
   */
  static format(config: Record<string, unknown> | null | undefined): string {
    return Object.entries(config ?? {})
      .map(([key, value]) => `${key}=${typeof value === 'string' ? value : JSON.stringify(value)}`)
      .join('\n');
  }

  /**
   * `key=value` 줄 → `config` 객체. 값이 빈 키도 유지한다(서버가 "미설정"으로 표시하는 자리다).
   *
   * `=` 없는 줄을 **버리지 않고 돌려준다** — 조용히 무시하면 사용자는 저장된 줄 알고 넘어가고,
   * 값이 안 들어간 이유를 어디서도 알 수 없다. 부르는 쪽이 저장을 막고 그 줄을 보여준다.
   */
  static parse(text: string): { config: Record<string, string>; invalid: string[] } {
    const config: Record<string, string> = {};
    const invalid: string[] = [];
    for (const line of text.split('\n')) {
      const trimmed = line.trim();
      if (!trimmed) continue;
      const at = trimmed.indexOf('=');
      // 첫 `=`로만 자른다 — 값에 `=`가 들어가도 살아남는다(쿼리 문자열·필터 표현식).
      if (at <= 0) { invalid.push(trimmed); continue; }
      config[trimmed.slice(0, at).trim()] = trimmed.slice(at + 1).trim();
    }
    return { config, invalid };
  }
}

export class Aliases {
  /** 쉼표·줄바꿈으로 구분한 별칭 입력 → 중복 없는 배열(서버 `aliasesOf`와 같은 정규화). */
  static parse(text: string): string[] {
    return [...new Set(text.split(/[,\n]/).map((value) => value.trim()).filter(Boolean))];
  }
}
